import React from 'react'
import { useSelector } from 'react-redux'
import styles from './Slider.module.scss'
import SliderBlockContent from '../../SliderView/components/SliderBlockContent/SliderBlockContent'

function Slider({}) {
  const slider = useSelector(state => state.slider.slider)
  const items = useSelector(state => state.slider.sliders)
  const slide = useSelector(state => state.slider.slide)
  return (
    <div className="col-md-9">
      <div className={styles["title-resentation"]}>{slider.name}</div>
      <div className={styles["Slide"]}>
        <div className={styles["item"]}>
          <div className={styles["container-item"]}>
            <SliderBlockContent items={items} activeItem={slide}/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Slider